import './MethodLogo.scss';

import type { FC } from 'react';
import React, { memo, useCallback, useState } from 'react';

const PLACEHOLDER_SVG =
  '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18 3C15 3 9 3 6 3C4.3 3 3 4.3 3 6C3 9 3 15 3 18C3 19.7 4.3 21 6 21C9 21 15 21 18 21C19.7 21 21 19.7 21 18C21 15 21 9 21 6C21 4.3 19.7 3 18 3ZM19 6C19 8.9 19 17.6 19 17.6L6.4 5C6.4 5 15.1 5 18 5C18.6 5 19 5.4 19 6ZM5 18C5 15.1 5 6.4 5 6.4L17.6 19C17.6 19 8.9 19 6 19C5.4 19 5 18.6 5 18Z" fill="#7B756B"/></svg>';

interface MethodLogoProps {
  src: string | undefined;
  alt: string;
  width: number;
  height: number;
}

const MethodLogoComponent: FC<MethodLogoProps> = ({ src, alt, width, height }) => {
  const [hasError, setHasError] = useState(false);

  const handleError = useCallback(() => {
    setHasError(true);
  }, []);

  if (hasError || !src) {
    return (
      <div
        className="method-logo method-logo--placeholder"
        data-testid="method-icon"
        data-id="method-logo"
        nonce={window.__webpack_nonce__}
        style={{
          width,
          height,
        }}
        dangerouslySetInnerHTML={{
          __html: PLACEHOLDER_SVG,
        }}
      />
    );
  }

  return (
    <div className="method-logo" data-testid="method-icon" data-id="method-logo">
      <img
        className="method-logo__img"
        src={src}
        alt={alt}
        width={width}
        height={height}
        onError={handleError}
        decoding="async"
        loading="lazy"
      />
    </div>
  );
};

export const MethodLogo = memo(MethodLogoComponent);
